/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-undef */
import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import { Typography } from '@mui/material';
import { Player } from '@lottiefiles/react-lottie-player';
import ModuleHeaderLayout from 'components/Common/Layouts/ModuleHeaderLayout';

const BiteViz: React.FC = () => {
  const bite_viz_dashboard = process.env.REACT_APP_BITE_VIZ_LINK!; // eslint-disable-line no-undef
  const { cur_user } = useContext(GlobalContext);
  const [userHasBiteViz, setUserHasBiteViz] = useState(false);

  const checkForBiteViz = () => {
    if (cur_user.selected_team?.attributes?.tier?.includes('enterprise')) {
      setUserHasBiteViz(true);
    }
  };

  useEffect(() => {
    checkForBiteViz();
  }, []);

  return (
    <ModuleHeaderLayout title='BITE VIZ' helpContent={''}>
      <div className='os-iframe'>
        <iframe className='os-iframe' src={bite_viz_dashboard}></iframe>
      </div>
    </ModuleHeaderLayout>
  );
};

export default BiteViz;
